import { render, staticRenderFns } from "./Funfacts.vue?vue&type=template&id=a6596054&"
import script from "./Funfacts.vue?vue&type=script&lang=js&"
export * from "./Funfacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports